import React from 'react';
import Modal from 'react-modal';
import '../CreateJobs/CreateJobs.css'
import Success from '../../../../JobseekerPage/DashBoardJob/ThirdJobTab/Animation/success.json';

const customStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  content: {
    width: '30%',
    height: '250px',
    margin: 'auto',
    backgroundColor: '#0054B3',
  },
};

Modal.setAppElement('#root'); 

function DraftedModal(props) {
    
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onClose}
      style={customStyles}
    >
      {/* <button onClick={props.onClose}>Close Modal</button> */}
      <Success/>
      <p className='text-center first-line'>Your Job Post has been Updated Successfully!</p>
      <p className='text-center second-line'>Have a Great Time!</p>
    </Modal>
    
  );
}

export default DraftedModal;
